import { TriageOutput } from 'enums';
import { messages } from 'i18n';

const { header } = messages.carrierSubmissionWorkspace;

export const triageOutputConfig: Record<TriageOutput, { label: string; color: string }> = {
  [TriageOutput.InGoodOrder]: { label: header.triage[TriageOutput.InGoodOrder], color: 'green.100' },
  [TriageOutput.NotInGoodOrder]: { label: header.triage[TriageOutput.NotInGoodOrder], color: 'error.light' },
};

export const getTriageOutputLabel = (value: TriageOutput) => triageOutputConfig[value].label;
